import { render, staticRenderFns } from "./listeDesVentesPart.vue?vue&type=template&id=1badf126&"
import script from "./listeDesVentesPart.vue?vue&type=script&lang=js&"
export * from "./listeDesVentesPart.vue?vue&type=script&lang=js&"
import style0 from "./listeDesVentesPart.vue?vue&type=style&index=0&id=1badf126&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports